export const head = {
    titleTemplate: 'Agence Prolifik -  %s',
    defaultTitle: 'Agence Prolifik',
    meta: [
        { name: 'description', content: 'Agence de stratégie web pour PME basée à Brossard et Québec' },
        { charset: 'utf-8' },
        { property: 'og:site_name', content: 'Agence Prolifik' },
        { property: 'og:image', content: 'http://agenceprolifik.ca/dev/img/2017/01/og-facebook-1200x630.jpg' },
        { property: 'og:image:width', content: '1200' },
        { property: 'og:image:height', content: '630' },
        { property: 'og:locale', content: 'fr_FR' },
        { property: 'og:title', content: 'Agence Prolifik' },
        { property: 'og:description', content: 'Agence de stratégie web pour PME basée à Brossard et Québec' },
    ]
};

export const apiHost = process.env.APIHOST || 'http://agenceprolifik.com';

export const apiHeader = [
    { name: 'Accept-Language', value: 'en' },
];



// WEBPACK FOOTER //
// ./clientConfig.js